import $ from 'jquery';
import Cookies from 'js-cookie';

if($(".calendar-content").length){
	const token = Cookies.get('XSRF-TOKEN');
	const memberId = document.querySelector("body").dataset.memberId;

	async function fetchCalendar(year, month){
		let result = localStorage.getItem(`calendar_${year}_${month}_${memberId}`);
		if(result){
			result = JSON.parse(result);
		}
		if(!result || result.expire < new Date().getTime() / 1000){
			const response = await fetch("/member/api/calendar?" + new URLSearchParams({year,month}),  {
				method: 'get',
				headers: {
					'X-XSRF-TOKEN': token
				}
			});
			if (!response.ok) {
				throw new Error(`レスポンスステータス: ${response.status}`);
			}
			result = await response.json();
			if(!result.date){
				throw new Error(`エラー: ${result.error}`);
			}
			localStorage.setItem(`calendar_${year}_${month}_${memberId}`, JSON.stringify(result));
		}
		return result;
	}

	async function generateCalendar(calendar, year, month) {
		const result = await fetchCalendar(year, month);

		const todayYear = new Date().getFullYear();
		const todayMonth = new Date().getMonth() + 1;
		const todayDay = new Date().getDate();

		const firstDay = new Date(year, month - 1, 1);
		const lastDay = new Date(year, month, 0);
		const startDay = firstDay.getDay();
		const totalDays = lastDay.getDate();

		const currentMonthLabel = calendar.querySelector('.current-month');
		if(currentMonthLabel){
			currentMonthLabel.textContent = `${year}.${month}`;
		}

		const calendarDiv = calendar.querySelector('.calendar-content');
		if(calendarDiv){
			let html = '<table><thead><tr>';
			const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
			for (let day of weekdays) {
				html += `<th>${day}</th>`;
			}
			html += '</tr></thead><tbody><tr>';

			for (let i = 0; i < startDay; i++) {
				html += '<td></td>';
			}

			for (let day = 1; day <= totalDays; day++) {
				const currentDay = (startDay + day - 1) % 7;
				html += `<td>${day}`;
				let className = "";
				if(year == todayYear && month == todayMonth && day == todayDay){
					className = `class="today"`;
				}
				switch(parseInt(result.date[day])){
					case 1:
						html += `<img ${className} src="/assets/img/member/calendar/condition01.svg" alt="ぜっこーちょー！" width="70" height="75" />`;
						break;
					case 2:
						html += `<img ${className} src="/assets/img/member/calendar/condition02.svg" alt="まあまあかな" width="70" height="75" />`;
						break;
					case 3:
						html += `<img ${className} src="/assets/img/member/calendar/condition03.svg" alt="ちょっとよくない" width="70" height="75" />`;
						break;
					case 4:
						html += `<img ${className} src="/assets/img/member/calendar/condition04.svg" alt="しんどい" width="70" height="75" />`;
						break;
				}
				html += `</td>`;
				if (currentDay === 6 && day !== totalDays) {
					html += '</tr><tr>';
				}
			}

			const lastDayOfWeek = (startDay + totalDays - 1) % 7;
			if (lastDayOfWeek < 6) {
				for (let i = lastDayOfWeek + 1; i <= 6; i++) {
					html += '<td></td>';
				}
			}

			html += '</tr></tbody></table>';
			calendarDiv.innerHTML = html;
		}
	}

	let isFirst = true;
	async function init(){
		let isRegister = false;
		if(isFirst){
			isRegister = true;
			isFirst = false;
		}
		const calendars = document.querySelectorAll(".calendar");
		for (const calendar of calendars) {
			let currentYear = new Date().getFullYear();
			let currentMonth = new Date().getMonth() + 1;
			let isProgress = false;

			async function changeMonth(offset) {
				if(isProgress) return;
				isProgress = true;
				currentMonth += offset;
				if (currentMonth < 1) {
					currentMonth = 12;
					currentYear--;
				} else if (currentMonth > 12) {
					currentMonth = 1;
					currentYear++;
				}
				await generateCalendar(calendar, currentYear, currentMonth);
				isProgress = false;
			}

			if(isRegister){
				calendar.querySelector('.prev')?.addEventListener('click', () => changeMonth(-1));
				calendar.querySelector('.next')?.addEventListener('click', () => changeMonth(1));
			}
			await generateCalendar(calendar, currentYear, currentMonth);
		};

		//今日の調子を選んでいなければダイアログを表示
		async function todayCheck(){
			const todayYear = new Date().getFullYear();
			const todayMonth = new Date().getMonth() + 1;
			const todayDay = new Date().getDate();
			document.querySelectorAll(".todayTime").forEach((el) => {
				const datetime = el.getAttribute("datetime");
				if(datetime != `${todayYear}-${todayMonth}-${todayDay}`){
					el.setAttribute("datetime",`${todayYear}-${todayMonth}-${todayDay}`);
					el.innerHTML = `<span class="year">${todayYear}.</span>${todayMonth}.${todayDay}`;
				}
			});

			if (document.visibilityState === 'visible') {
				const result = await fetchCalendar(todayYear,todayMonth);
				if(!result.date[todayDay]){
					document.querySelector("#calendarPopup .condition").style.display = 'block';
					document.querySelector("#calendarPopup").showModal();
				}else{
					document.querySelector("#calendarPopup .condition").style.display = 'none';
				}
			}
		}
		todayCheck();
		if(isRegister){
			setInterval(todayCheck, 1000);
			document.querySelector("#calendarPopup").addEventListener("close", async (event) => {
				await todayCheck();
				if(document.querySelector("#calendarPopup").open){
					alert("今日の調子をえらんでください");
				}
			});
		}
	}
	init();

	//今日の調子選択
	document.querySelectorAll("#calendarPopup .condition button").forEach((el) => {
		el.addEventListener("click", async function() {
			const todayYear = new Date().getFullYear();
			const todayMonth = new Date().getMonth() + 1;
			const todayDay = new Date().getDate();

			const response = await fetch("/member/api/calendar",  {
				method: 'post',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'X-XSRF-TOKEN': token
				},
				body: new URLSearchParams({
					year: todayYear,
					month: todayMonth,
					day: todayDay,
					condition: el.dataset.condition
				})
			});
			if (!response.ok) {
				throw new Error(`レスポンスステータス: ${response.status}`);
			}
			const result = await response.json();
			if(!result.date){
				throw new Error(`エラー: ${result.error}`);
			}
			localStorage.setItem(`calendar_${todayYear}_${todayMonth}_${memberId}`, JSON.stringify(result));

			init();
		});
	});
}